import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GenericDetailsComponent } from './generic-details.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: GenericDetailsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class GenericDetailsRoutingModule { }
